<style scoped lang="scss">
.hardship-reason {
  font-size: 1.2em;
  margin-bottom: 8px;

  .reason-text {}
}

.member-hardship-container {
  .member-title {
    font-size: 1.4em !important;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .member-section {
    margin-left: 0px;
  }
}

.label-large {
  font-size: 1.3em;
  margin-bottom: 25px;

  display: flex;

  input[type=checkbox] {
    transform: scale(1.3);
    margin-right: 6px;
  }
}
.financial-item {
  font-size: 1.2em;
  margin-bottom: 8px;
  display: flex;
}

.checkbox-container {
  margin-right: 6px;
  height: 100%;
}

.vue-dropzone {
  background: #eee;
  border: thin dashed #666;
}
</style>

<template>
  <div class="uk-form" v-if="application">
    <div class="uk-grid uk-margin-top uk-margin-large-bottom">
      <div class="uk-width-1-1 uk-margin-bottom">
        <p style="color: red;">{{ selection_pass_error }}</p>
        <h2 class="uk-align-center">
          {{ __('tenant.cov_title', { program: application.program.program_abbreviation }) }}
        </h2>
        <i><strong>
            {{ __(`tenant.cov_subtitle`, { program_abbreviation: application.program.program_abbreviation }) }}
          </strong></i>
      </div>

      <div class="uk-width-1-1 member-hardship-container" v-for="(member, i) in hhMembers" v-if="i === 0">
        <!-- Financial Hardship -->
        <div class="member-title">Financial Hardship</div>
        <h3>My household is at risk of eviction due to financial hardship. Please check all that apply:</h3>
        <div class="uk-grid uk-margin-bottom uk-margin-small-top member-section">
          <div class="uk-width-1-1">
            <div class="financial-item" v-for="(reason, reasonKey) in financialHardshipReasons">
              <div class="checkbox-container">
                <input type="checkbox" v-model="member.financial_hardship_reasons" :id="`financial_covid_hardship_${reasonKey}`" :value="reason.id">
              </div>
              <label :for="`financial_covid_hardship_${reasonKey}`" class="reason-text">{{ reason.body }}</label>
            </div>
            <div class="uk-margin-top">
              <label :for="`financial_hardship_reason_explain_${member.id}`">Additional Details of Financial Hardship: In about 5 sentences or less, please tell us what has happened most recently in the past few months that has caused your rent to go unpaid. You do not need to disclose sensitive information to receive services that you are eligible for.<br /></label>
              <textarea rows="3" id="`financial_hardship_reason_explain_${member.id}`" v-model="member.financial_hardship_reason_explain" class="uk-textarea uk-text-large uk-margin-small-top" placeholder=""></textarea>
            </div>
          </div>
        </div>
        <br/>
        <!-- / Financial Hardship -->

        <!-- Clackamas County Social Services -->
        <div class="member-title">Clackamas County Social Services</div>
        <h3>Rent Assistance Self-Declaration of Housing Status</h3>
        <p>Check only one box (Category)</p>
        <p>The most common Category for households to check who are applying for Short Term Rent Assistance (STRA) is Category 5 Unstably Housed. Please look at Category 5 first to see if it applies to your households current housing situation.<br/>
          The next most common Categories are 2 and 4. You can only check one Category, even if multiple categories apply to your housing situation. For this program, all categories will meet the eligibility criteria. This means the type of category you choose will not affect your eligibility as long as at least one of them is true.</p>
        <validated-section :errors="errors" field="self_declaration">
        </validated-section>
        <div class="uk-grid uk-margin-bottom uk-margin-small-top member-section">
          <div class="uk-width-1-1">
            <div class="financial-item" v-for="(reason, reasonKey) in selfDeclartionTerms">
              <div class="checkbox-container">
                <input type="radio" v-model="member.self_declaration" :id="`self_declaration_${reasonKey}`" :value="reason.id">
              </div>
              <label :for="`self_declaration_${reasonKey}`" class="use-hand-cursor">{{ reason.body }}</label>
            </div>
          </div>
        </div>
        <br/>
        <!-- / Financial Hardship -->
      </div> <!-- End Member Loop -->
    </div>


    <div class="uk-grid" v-if="applicant">
      <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-1">
        <p v-html="__('tenant.cov_under_penalty', { program: application.program.program_abbreviation })">
        </p>
        <validated-section :field="'signature_' + applicant.id" :errors="errors">
          <signature-box @updated="onSignatureUpdated" :user-key="applicant.id"
            :is-signed="signatureData[applicant.id] && signatureData[applicant.id].signed_at !== null"
            :completed="signatureData[applicant.id] && signatureData[applicant.id].completed"
            :name="applicant.first_name + ' ' + applicant.last_name"
            :color="programSettings['primary-program-color']"></signature-box>
        </validated-section>
      </div>
    </div>

    <p style="color: red;" id="footer-error"></p>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ValidatedSection from "../../../../../components/Common/ValidatedSection";
import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
import VueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import DropzoneUploader from "../../../../../components/AppWizard/Documents/DropzoneUploader";

export default {
  name: "CovidHardshipReasons",
  components: { DropzoneUploader, SignatureBox, ValidatedSection, VueDropzone },
  data() {
    return {
      errors: {},
      selection_pass_error: '',
      dropzoneOptions: {
        url: '/api/hope/documents',
        thumbnailWidth: 200,
        addRemoveLinks: true,
        maxFiles: 1,
        acceptedFiles: ['.pdf', '.png', '.jpg', '.jpeg'].join(','),
      },
      signatureData: {},
    }
  },
  computed: {
    ...mapState('Application', {
      application: state => state.application,
      applicant: state => state.applicant,
      hhMembers: state => state.application.household.members,
      reasons: state => state.assets.hardshipReasons,
      financialHardshipReasons: state => state.assets.financialHardshipReasons,
      selfDeclartionTerms: state => state.assets.selfDeclartionTerms,
      signatures: state => state.signatures,
    }),
    ...mapState('App', {
      env: state => state.env,
    }),
    ...mapGetters('Application', ['programSettings']),
  },
  watch: {
    application(newValue) {
      if (newValue) {
        this.initData();
      }
    }
  },
  mounted() {
    if (this.application) {
      this.initData();
    }
  },
  methods: {
    initData() {
      const signatureFiltered = this.signatures && this.signatures.find(item => item.key === `app-hardship`)
      if (signatureFiltered) {
        this.$set(this.signatureData, this.applicant.id, {
          signed_at: signatureFiltered.created_at,
          completed: true
        });
      }
    },

    addFinding(member) {
      member.finding_types.push({
        pivot: {
          finding_type_id: null,
          finding_type_level: null,
          household_application_id: this.application.id,
          household_member_id: member.id,
          household_id: member.household_id,
          notes: '',
        }
      })
    },
    formDataForMember(member) {
      return {
        household_application_id: this.application.id,
        household_member_id: member.id,
        applicant_user_id: this.application.applicant_user_id,
        file_type: 'proof_of_hardship',
      }
    },
    onMaxFilesExceeded(file) {
      console.log('max files exceeded', file);
    },
    onSignatureUpdated($event) {
      if (!this.signatureData[$event.key]) {
        this.$set(this.signatureData, $event.key, {});
      }
      this.$set(this.signatureData, $event.key, { signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null });
    },
    async validateStep() {
      this.errors = {};
      let page_error = document.getElementById('footer-error');

      let member = _.first(this.hhMembers);
      
      if (this.selfDeclartionTerms && this.selfDeclartionTerms.length && !member.self_declaration) {
        this.errors['self_declaration'] = { errors: ['You must select at least one category.'] }
      }

      if (!this.signatureData[this.applicant.id]) {
        this.errors['signature_' + this.applicant.id] = {
          errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
        };
      } else if (this.signatureData[this.applicant.id] && this.signatureData[this.applicant.id].signed_at == null) {
        this.errors['signature_' + this.applicant.id] = {
          errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
        };
      }

      let errorCount = _.size(this.errors);

      if (errorCount > 0) return false;

      // Server Side Validation
      try {
        let response = await this.save();
        return true;
      } catch (err) {
        console.error(err);
      }

    },
    async save() {

      let _members = _.map(this.application.household.members, member => _.pick(member, [
        'id',
        'is_unemployed',
        'date_unemployed',
        'date_apply_unemployed',
        'date_award_unemployed',
        'date_reemployed',
        'experienced_covid_hardship',
        'financial_hardship_reasons',
        'financial_hardship_reason_explain',
        'self_declaration',
        'finding_types',
      ]))

      let data = {
        signatures: this.signatureData,
        members: _members,
      }
      return await axios.put(`/api/hope/applications/${this.application.id}/step-hardship-reason`, data)
    },
  }
}
</script>
